import { Component, Vue, Prop } from 'vue-property-decorator';
import { OnboardingRegistrationOdinAccount, OnboardingRegistration } from '@/common/models';

@Component({
  components: {
  },
})
export default class RegistrationDetailsCloudAccount extends Vue {
  @Prop({required: true}) onboardingRegistrationOdinAccount!: OnboardingRegistrationOdinAccount;
}
